import React, { useEffect, useState } from "react";
import apiClient from "../../../shared/API/apiClient";
import { useNavigate } from "react-router-dom";

export default function RolePermissionPage() {

    const [loading,setLoading] = useState(true);

    const [roles,setRoles] = useState([]);

    const [selectedRole,setSelectedRole] = useState(null);

    const [roleDetail,setRoleDetail] = useState(null);
    const navigate = useNavigate();

    useEffect(()=>{
        loadRoles();
    },[]);

    const loadRoles = async()=>{

        try{

            const res = await apiClient.get("/api/users/roles");

            setRoles(res.data.data || []);

            if(res.data.data.length){

                loadPermissions(res.data.data[0].id);

            }

        }finally{

            setLoading(false);

        }

    };

    const loadPermissions = async(roleId)=>{

        const res = await apiClient.get(`/api/users/${roleId}/permissions`);

        setSelectedRole(roleId);

        setRoleDetail(res.data);

    };

    if(loading){

        return <div className="page-loader">Loading...</div>;

    }

    return(

  <div className="dash-page">
        <div className="le-page-header">
        <div>
            <div className="dash-page-title">Roles &amp; Permissions</div>

            <div className="dash-page-subtitle">Fixed system roles and their access levels</div>
            </div>
                   
        </div>
        
<div class="le-card">
<div class="table-wrap">
  <table class="le-table">
  <thead>
      <tr>
        <th>Role</th>
        <th>Permissions</th>
        <th>Description</th>
        
        <th>Actions</th>
      </tr>
    </thead>

    <tbody>
    {roles.map(role=>(

    <tr>
        <td class="le-entity-name" data-label="Entity Name">
           {role.name}
        </td>
        <td class="le-entity-name" data-label="Entity Name">
           {role.role_action}
        </td>
        <td class="le-entity-name" data-label="Entity Name">
          {role.description}
        </td>
        <td data-label="Actions">
          <div class="le-actions">
         {role.isdefault === 0 ? (
  <span className="action-item edit">
    <i
      className="fa-solid fa-key"
      title="Permissions"
      onClick={() => navigate(`/dashboard/roles/${role.id}/permissions`)}
    />
  </span>
) : (
  <span
    className="action-item disabled"
    title="Can't be Edited"
  >
    Can't be Edited
  </span>
)}

            
          </div>
        </td>
        </tr>
        ))}
    </tbody>
  </table>


</div>
       
</div>
<div className="role-content">

    </div>
    </div>

    );

}